import { path } from 'ramda';

export const isLegalFieldsEnabled = settings => path(['optOrgStruct'], settings) || path(['optOrgStructAndStaffing'], settings);
export const isFullLegalFieldsEnabled = settings => path(['optOrgStructAndStaffing'], settings);
